import { buildModelManager } from "../builder.js";
const DefaultBulkJobResultV2Selection = {
  __typename: true,
  id: true,
  createdAt: true,
  error: true,
  jobId: true,
  rawOutput: { markdown: true, truncatedHTML: true },
  resultJson: true,
  shardIndex: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "bulkJobResultV2";
const pluralModelApiIdentifier = "bulkJobResultV2s";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultBulkJobResultV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultBulkJobResultV2Selection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBulkJobResultV2Selection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBulkJobResultV2Selection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBulkJobResultV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultBulkJobResultV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultBulkJobResultV2Selection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createBulkJobResultV2",
    operationReturnType: "CreateBulkJobResultV2",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      bulkJobResultV2: { required: false, type: "CreateBulkJobResultV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultBulkJobResultV2Selection
  },
  {
    type: "action",
    operationName: "bulkCreateBulkJobResultV2s",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateBulkJobResultV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultBulkJobResultV2Selection
  },
  {
    type: "action",
    operationName: "updateBulkJobResultV2",
    operationReturnType: "UpdateBulkJobResultV2",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      bulkJobResultV2: { required: false, type: "UpdateBulkJobResultV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultBulkJobResultV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpdateBulkJobResultV2s",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateBulkJobResultV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultBulkJobResultV2Selection
  },
  {
    type: "action",
    operationName: "deleteBulkJobResultV2",
    operationReturnType: "DeleteBulkJobResultV2",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteBulkJobResultV2s",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertBulkJobResultV2",
    operationReturnType: "UpsertBulkJobResultV2",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      bulkJobResultV2: { required: false, type: "UpsertBulkJobResultV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateBulkJobResultV2Result": { hasReturnType: false },
      "... on UpdateBulkJobResultV2Result": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultBulkJobResultV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpsertBulkJobResultV2s",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertBulkJobResultV2sInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultBulkJobResultV2Selection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "bulkJobResultV2GellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const BulkJobResultV2Manager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultBulkJobResultV2Selection,
  operations
);
export {
  BulkJobResultV2Manager,
  DefaultBulkJobResultV2Selection
};
//# sourceMappingURL=BulkJobResultV2.js.map
